import { render, staticRenderFns } from "./_base-flex-modal.vue?vue&type=template&id=8ceee412&scoped=true&"
import script from "./_base-flex-modal.vue?vue&type=script&lang=js&"
export * from "./_base-flex-modal.vue?vue&type=script&lang=js&"
import style0 from "./_base-flex-modal.vue?vue&type=style&index=0&id=8ceee412&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ceee412",
  null
  
)

export default component.exports